export default "__VITE_ASSET__DaVpTzLJ__"